import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import isFunction from "lodash/isFunction"
import resourceTypeModel from "src/models/resourceType"
import collection from "src/hocs/collection"

const configuration = {
  engine: entity,
  to: `resourceTypes`,
  model: resourceTypeModel,
  query: {
    limit: -1,
  },
}

export default config =>
  compose(
    collection(props => ({
      ...configuration,
      ...(isFunction(config) ? config(props) : config),
    })),
  )
